import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-shop-single-product-page',
  templateUrl: './shop-single-product-page.component.html',
  styleUrls: ['./shop-single-product-page.component.css']
})
export class ShopSingleProductPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  	$('#initialise-page').trigger('click');
  }

}
